<template>
  <div class="compare-list">
    <div class="list-top">
      <div>
        <template v-if="allowFlow">
          <el-button type="danger m-b-10" @click="$emit('cancelCandidate')">
            取消部分采购
          </el-button>
          <el-tooltip
            class="item"
            effect="dark"
            content="选择品目进行取消采购，取消采购的品目将不会出现在候选及成交信息中"
            placement="top-start"
          >
            <i class="el-icon-question font-16 m-l-6 text-warning"></i>
          </el-tooltip>
        </template>
      </div>

      <div class="flex col-center m-b-10">
        <div class="compare-tips m-r-16">
          <div class="compare-tips__item lowest">最低价</div>
          <div class="compare-tips__item highest">最高价</div>
        </div>
        <div v-if="useSort" class="m-r-16">
          <span class="m-r-8">供应商排序</span>
          <el-select
            v-model="sortType"
            placeholder="请选择"
            @change="handleChangeSort"
          >
            <el-option
              v-for="item in sortTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div v-if="inMultiple" class="multiple-tips">
          <span class="multiple-tips__important">
            选择需要进行多轮报价的品目
          </span>
          <span>未选择进行多轮报价的品目，将保留上一次的报价结果</span>
        </div>

        <el-button
          v-if="isNeedLowestTotal"
          type="primary"
          class="flex-center"
          @click="handleSelectLowestTotal"
        >
          一键选择总价最低
        </el-button>
        <el-button
          v-if="exportPriceComparison"
          type="primary"
          class="flex-center"
          @click="handleExportPdf"
        >
          导出pdf
        </el-button>
        <el-button
          v-else-if="needGrand"
          type="primary"
          class="flex-center"
          @click="handleSelectLowest"
        >
          一键选择分项最低
        </el-button>

        <el-button
          v-if="!needGrand && !inMultiple && !showDropDownload"
          type="primary"
          size="medium"
          class="flex-center"
          @click="exportCompareInfo"
        >
          导出比价单结果
        </el-button>

        <el-dropdown v-if="showDropDownload" class="flex-center m-l-10">
          <el-button type="primary" size="medium">
            导出比价单结果
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span @click="exportCompareInfo">导出比价单结果</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span @click="exportQuotaInfo">导出报价信息表</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-table
      ref="table"
      :key="tableKey"
      :data="pageTableData"
      border
      :span-method="objectSpanMethod"
      row-key="rowKey"
      :header-cell-style="{ background: '#f5f5f5' }"
      @select-all="handleSelectAll"
      @select="handleSelect"
    >
      <el-table-column
        v-if="inMultiple || isSelection"
        type="selection"
        width="55"
        reserve-selection
      />
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
        :index="indexMethod"
      />
      <el-table-column label="品目信息" min-width="340px" fixed="left">
        <template v-slot="{ row }">
          <div
            v-for="item in materielInfoConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span
              v-if="item.columnName === '分类' && row.categoryNameTree"
              class="info-item-value"
            >
              {{ row.categoryNameTree.join('>') || '-' }}
            </span>
            <span v-else class="info-item-value">
              {{ row[item.defineCode] || '-' }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="采购量/单位" min-width="90px" fixed="left">
        <template v-slot="{ row }">
          <span>
            {{ row[numConfig.defineCode] }}/{{ row[unitConfig.defineCode] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px" fixed="left" label="展开与收起">
        <template v-slot:header>
          <el-button
            type="text"
            :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
            @click="isCollapse = !isCollapse"
          >
            {{ isCollapse ? '收起全部' : '展开查看更多' }}
          </el-button>
        </template>
        <template v-slot:default>
          <p>
            点击上方可{{
              isCollapse ? '收起' : '展开'
            }}查看参数型号、预算价格、备注等信息
          </p>
        </template>
      </el-table-column>
      <template v-if="isCollapse">
        <el-table-column
          :label="`预算单价(${isDollar ? '美元' : '元'})`"
          min-width="90px"
        >
          <template v-slot="{ row }">
            <span>{{ row[unitPriceConfig.defineCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="`预算总价(${isDollar ? '美元' : '元'})`"
          min-width="90px"
        >
          <template v-slot="{ row }">
            <span>{{ row.totalPrice }}</span>
            <money-in-cn v-if="!isDollar" :money="row.totalPrice || 0" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="controlPriceConfig.isEnable"
          :label="
            `${controlPriceConfig.columnName.replace('（元）', '')}(${
              isDollar ? '美元' : '元'
            })`
          "
          min-width="90px"
        >
          <template slot-scope="{ row }">
            <span>{{ row.controlPrice }}</span>
            <money-in-cn v-if="!isDollar" :money="row.controlPrice || 0" />
          </template>
        </el-table-column>
        <!-- 不能连续两个v-if，表头会出现丢失现象 -->
        <el-table-column v-if="modelConfig.isEnable" label="参数型号">
          <template slot-scope="{ row }">
            <span>{{ row[modelConfig.defineCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对供应商备注" min-width="90px">
          <template slot-scope="{ row }">
            <span>{{ row.remarks || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部备注" min-width="90px">
          <template slot-scope="{ row }">
            <span>{{ row.insideRemark || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="附件" min-width="160px">
          <template slot-scope="{ row }">
            <upload
              v-if="row.attachmentFileIds && row.attachmentFileIds[0]"
              :props-data="{
                disabled: true,
                uploadMode: 'fileId',
                fileIdBefore: row.attachmentFileIds[0]
              }"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="采购人指定" min-width="340px">
          <template v-slot="{ row }">
            <div
              v-for="item in purchaseSpecifyConfig"
              :key="item.defineCode"
              class="info-item"
            >
              <span class="info-item-label">{{ item.columnName || '-' }}</span>
              <span class="info-item-value">
                {{ row[item.defineCode] || '-' }}
              </span>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column label="报价供应商" min-width="340px" align="center">
        <el-table-column
          label="供应商响应信息"
          prop="offerName"
          min-width="120px"
        >
          <template #default="{ row }">
            <div v-if="row.offerName === '议价'" class="supplier-response">
              <el-checkbox v-model="row.isBargain" @change="changeBargain(row)">
                议价
              </el-checkbox>
            </div>
            <span
              v-else
              :class="{ 'text-primary': row.offerName === '选择授标数量' }"
            >
              {{ row.offerName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in supplierHead"
          :key="item.supplierName"
          :label="`${item.supplierName}`"
          align="center"
          min-width="160px"
        >
          <template #header>
            <a-checkbox
              v-if="showCheckbox"
              style="display: flex; align-items: center"
              :checked="item.checkAll"
              :indeterminate="item.isIndeterminate"
              @change="handleSupplierCheck(item)"
            >
              <div>{{ item.supplierName }}</div>
              <div class="flex col-stretch row-center flex-wrap">
                <div style="white-space: nowrap">报价总金额：</div>
                <div class="flex flex-column col-top">
                  {{
                    item[offerTotalPriceField]
                      ? strToThousands(item[offerTotalPriceField])
                      : 0
                  }}
                  {{ isDollar ? '美元' : '元' }}
                </div>
              </div>
              <div
                v-if="isBargainTotal"
                class="flex col-stretch row-center flex-wrap"
              >
                <div style="white-space: nowrap">议价后总金额：</div>
                <div class="flex flex-column col-top text-danger">
                  {{
                    getBargainTotal(item)
                      ? strToThousands(getBargainTotal(item))
                      : 0
                  }}

                  {{ isDollar ? '美元' : '元' }}
                </div>
              </div>
              <div
                v-if="item.contactUserName"
                class="flex col-stretch row-center flex-wrap"
              >
                <div style="white-space: nowrap">联系人：</div>
                <div class="flex flex-column col-top">
                  {{ item.contactUserName }}
                </div>
              </div>
              <div
                v-if="item.contactUserPhone"
                class="flex col-stretch row-center flex-wrap"
              >
                <div style="white-space: nowrap">联系电话：</div>
                <div class="flex flex-column col-top">
                  {{ item.contactUserPhone }}
                </div>
              </div>
              <div v-if="showReviewScore">评审得分：{{ item.reviewScore }}</div>
            </a-checkbox>
            <template v-else>
              <div>{{ item.supplierName }}</div>
              <div class="flex col-stretch row-center flex-wrap">
                <div style="white-space: nowrap">报价总金额：</div>
                <div class="flex flex-column col-top">
                  {{
                    item[offerTotalPriceField]
                      ? strToThousands(item[offerTotalPriceField])
                      : 0
                  }}
                  {{ isDollar ? '美元' : '元' }}
                </div>
              </div>
              <div v-if="showReviewScore">评审得分：{{ item.reviewScore }}</div>
            </template>
          </template>
          <template #default="{ row, $index }">
            <div
              v-if="row.offerName === '选择授标数量'"
              class="flex-align__around"
            >
              <a-checkbox
                :checked="row.offerValue[item.supplierId].check"
                style="margin-right: 0.5rem;"
                :disabled="!row.offerValue[item.supplierId].detailId"
                @change="checkChange(row, item)"
              />
              <el-input-number
                v-model.number="row.offerValue[item.supplierId].num"
                placement="请输入数量"
                :disabled="!row.offerValue[item.supplierId].check"
                size="mini"
                :min="0"
                :precision="2"
                :controls="false"
                @blur="checkNumber(row)"
              />
            </div>
            <div
              v-else-if="row.offerName === '议价'"
              class="flex-align__around"
            >
              <el-input-number
                v-model.number="row.offerValue[item.supplierId].bargainAmount"
                placement="请输入价格"
                :disabled="
                  !isNumChecked($index, item.supplierId) || !row.isBargain
                "
                size="mini"
                :min="0"
                :precision="2"
                :controls="false"
              />
              <span class="m-l-8">元</span>
            </div>
            <div
              v-else-if="row.offerName === '轮次'"
              :class="
                row.offerValue[item.supplierId].currentRound
                  ? ''
                  : 'no-current-round'
              "
              :style="{
                'text-align': alignRight(row, item) ? 'right' : 'center'
              }"
            >
              {{ roundNumHandle(row.offerValue[item.supplierId].roundNum) }}
            </div>
            <div
              v-else
              :class="getTextColor(row, item)"
              :style="{
                'text-align': alignRight(row, item) ? 'right' : 'center'
              }"
            >
              {{ getRowValue(row, item) }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <!--前端模拟分页-->
    <pagination
      v-show="tableDataTemp.length > size"
      :total="tableDataTemp.length / spanNum"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具
import { cloneDeep, uniqBy } from 'lodash'
import nzhcn from 'nzh/cn'
import { strToThousands } from '@/utils/utils'
import { sortTypeDict } from '@/dictionary/project/inquiry'
import { watermarkTypeDict } from '@/dictionary/template'
import {
  getFileUrlByFileIdApi,
  htmlToPdfApi,
  downloadsHistoryApi
} from '@/api/up-file'
import { getInquiryOfferComparePdfApi } from '@/api/procure/inquiry'
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { generateMaterielOfferHtml } from './generate-materiel-offer-html'
import qrcode from 'qrcode'
import { messageVerificationDict } from '@/dictionary/project/common'

/**
 * @description 采购清单全选比价表
 */
export default {
  name: 'PurchaseListCompare',

  components: { Upload, Pagination, MoneyInCn },

  mixins: [materialColumnMixin],

  model: {
    prop: 'tableData',
    event: 'change'
  },

  props: {
    // 交易单id
    orderId: {
      type: [Number, String],
      default: ''
    },

    // 轮次id
    roundId: {
      type: [Number, String],
      default: 1
    },

    // 是否需要含税
    requireTax: {
      type: Boolean,
      default: false
    },

    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 需要跨越的行
    spanNum: {
      type: Number,
      default: 1
    },

    headerList: {
      type: Array,
      default: () => []
    },

    // 是否可以多选表格项
    isSelection: {
      type: Boolean,
      default: false
    },

    // 发起多轮报价中
    inMultiple: {
      type: Boolean,
      default: false
    },

    // 需要授标操作
    needGrand: {
      type: Boolean,
      default: false
    },

    // 是否展示授标量
    showAward: {
      type: Boolean,
      default: false
    },

    // 导出询比比价单
    exportPriceComparison: {
      type: Boolean,
      default: false
    },

    // 已选择的品目id
    echoList: {
      type: Array,
      default: () => []
    },

    // 是否显示排序
    useSort: {
      type: Boolean,
      default: false
    },

    // 供应商报价总金额字段
    offerTotalPriceField: {
      type: String,
      default: 'offerAmount'
    },

    isDollar: {
      type: Boolean,
      default: false
    },

    // 导出比价单结果是否下拉多项按钮
    showDropDownload: {
      type: Boolean,
      default: false
    },

    // 是否显示 议价后总金额
    isBargainTotal: {
      type: Boolean,
      default: false
    },

    // 是否需要 一键选择总价最低
    isNeedLowestTotal: {
      type: Boolean,
      default: false
    },

    // 是否显示评审得分
    showReviewScore: {
      type: Boolean,
      default: false
    },

    // 使用允许部分品目流标
    allowFlow: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      tableDataTemp: [],
      // 供应商报价表头
      supplierHead: [],

      // 前端模拟分页
      page: 1,
      size: 20,
      pageTableData: [],

      // 排序方式
      sortType: sortTypeDict.OFFER_PRICE_ASC.value,
      // 排序方式选项字典
      sortTypeDict,

      tableKey: false,

      // 是否展开
      isCollapse: false,

      // 选中数组
      multipleSelection: []
    }
  },

  computed: {
    // 显示勾选框
    showCheckbox() {
      // 当列表数据中有一行的offerName为选择授标数量时，显示勾选
      return this.tableDataTemp.some(row => row.offerName === '选择授标数量')
    },

    sizeMultiple() {
      return this.size * this.spanNum
    },

    indexMethod() {
      return index => {
        return Math.round(index / this.spanNum + 1)
      }
    },

    sortTypeOption() {
      if (this.showReviewScore) {
        return sortTypeDict.array
      }
      return [sortTypeDict.OFFER_PRICE_ASC, sortTypeDict.OFFER_PRICE_DESC]
    },

    businessCode() {
      const timeStamp = new Date().getTime()
      return `${this.orderId}-${messageVerificationDict.INQUIRY_COMPARE.value}-${timeStamp}`
    }
  },

  watch: {
    itemSchemaList: {
      handler(val) {
        if (val.length > 0) {
          this.setColumnConfig(val)
        }
      },
      deep: true,
      immediate: true
    },

    headerList: {
      handler(val) {
        if (val.length > 0) this.setSupplierHead()
      },
      deep: true,
      immediate: true
    },

    echoList: {
      handler(val) {
        this.getIntersectionAndSelect()
      },
      immediate: true
    },

    tableDataTemp: {
      handler(val) {
        this.$emit('change', cloneDeep(val))
      },
      deep: true
    },

    tableData: {
      handler(val) {
        const tableDataTemp = cloneDeep(
          val.map((value, index) =>
            Object.assign({}, value, { rowKey: `${value.materielId}-${index}` })
          )
        )
        if (
          JSON.stringify(this.tableDataTemp) !== JSON.stringify(tableDataTemp)
        ) {
          this.tableDataTemp = tableDataTemp
        }

        this.getPageData()
        this.getIntersectionAndSelect()
        this.$nextTick(() => {
          this.supplierHead.forEach(item => {
            item.checkedMaterial = []
            item.someDisabled = 0
            for (
              let i = this.spanNum - 1;
              i < this.tableDataTemp.length;
              i += this.spanNum
            ) {
              const offerValue = this.tableDataTemp[i].offerValue[
                item.supplierId
              ]
              if (offerValue.check) {
                item.checkedMaterial.push(this.tableDataTemp[i].materielId)
              }
              if (!offerValue.detailId) {
                item.someDisabled++
              }
            }
            // 检查当前供应商是否所有品目都授标
            const checkAll =
              item.checkedMaterial.length ===
              this.tableDataTemp.length / this.spanNum - item.someDisabled
            // 检查当前供应商是否有部分品目授标
            const someCheck = item.checkedMaterial.length > 0
            item.isIndeterminate = !checkAll && someCheck
            item.checkAll = checkAll
          })
        })
      },
      deep: true,
      immediate: true
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    },

    showReviewScore(val) {
      if (val) {
        // 线上评审项目，默认按评审得分降序排序
        this.sortType = sortTypeDict.SCORE_DESC.value
      }
    }
  },

  methods: {
    strToThousands,

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 以收取展开列的下标为开始，以供应商名称的下标为结束，生成中间需要跨行展示的列号数组
      const START_INDEX = this.$refs.table.columns.findIndex(
        item => item.label === '展开与收起'
      )
      const END_INDEX = this.$refs.table.columns.findIndex(
        item => item.label === '供应商响应信息'
      )
      const defaultColumnIndexArray = [...Array(START_INDEX + 1).keys()]
      const expandColumnIndexArray = this.isCollapse
        ? [...Array(END_INDEX).keys()].slice(START_INDEX)
        : []
      const columnIndexArray = [
        ...defaultColumnIndexArray,
        ...expandColumnIndexArray
      ]

      if (columnIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex % this.spanNum === 0) {
          return {
            rowspan: this.spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    /**
     * 设置供应商表头排序
     */
    setSupplierHead() {
      const tempList = cloneDeep(this.headerList) || []
      this.supplierHead = tempList.map(item => {
        item.checkedMaterial = []
        item.someDisabled = 0
        for (
          let i = this.spanNum - 1;
          i < this.tableDataTemp.length;
          i += this.spanNum
        ) {
          const offerValue = this.tableDataTemp[i].offerValue[item.supplierId]
          if (offerValue.check) {
            item.checkedMaterial.push(this.tableDataTemp[i].materielId)
          }
          if (!offerValue.detailId) {
            item.someDisabled++
          }
        }
        // 检查当前供应商是否所有品目都授标
        const checkAll =
          item.checkedMaterial.length ===
          this.tableDataTemp.length / this.spanNum - item.someDisabled
        // 检查当前供应商是否有部分品目授标
        const someCheck = item.checkedMaterial.length > 0
        item.isIndeterminate = !checkAll && someCheck
        item.checkAll = checkAll
        return item
      })
      this.tableKey = !this.tableKey
    },

    /**
     * 处理供应商表头勾选事件
     */
    handleSupplierCheck(supplier) {
      if (!supplier.checkAll) {
        // 先检查是否有其他公司已授标
        const otherCheck = this.supplierHead.some(item => {
          return (
            item.supplierId !== supplier.supplierId &&
            item.checkedMaterial.length > 0
          )
        })
        if (otherCheck) {
          this.$antConfirm({
            title: '授标确认',
            content: '有其他公司存在授标信息，确定后将取消其他公司的授标信息',
            icon: () => <a-icon type='exclamation-circle' />,
            onOk: () => {
              // 先清除所有授标信息
              for (
                let i = this.spanNum - 1;
                i < this.tableDataTemp.length;
                i += this.spanNum
              ) {
                const row = this.tableDataTemp[i]
                for (const i in row.offerValue) {
                  row.offerValue[i].check = false
                  row.offerValue[i].num = ''
                }
              }
              this.supplierHead.forEach(item => {
                item.checkAll = false
                item.isIndeterminate = false
                item.checkedMaterial = []
              })
              this.handleSupplierCheckAll(supplier)
            }
          })
          return
        }
        if (supplier.isIndeterminate) {
          // 在有部分已选的情况下，先弹窗待用户确认，再进行全选
          this.$antConfirm({
            title: '全部授标确认',
            content: '当前存在部分授标情况，确定后将全部授标',
            icon: () => <a-icon type='exclamation-circle' />,
            onOk: () => {
              this.handleSupplierCheckAll(supplier)
            }
          })
          return
        }
        this.handleSupplierCheckAll(supplier)
      } else {
        this.handleSupplierCheckAll(supplier)
      }
    },

    /**
     * 单个供应商单个品目勾选变化
     * @param {Object} row 当前行信息
     * @param {Object} item 当前列的供应商数据
     */
    checkChange(row, item) {
      const tempItem = row.offerValue[item.supplierId]
      if (tempItem.check) {
        tempItem.check = false
        tempItem.num = ''
        const tempIndex = item.checkedMaterial.indexOf(row.materielId)
        item.checkedMaterial.splice(tempIndex, 1)
      } else {
        tempItem.check = true
        tempItem.num = Number(row[this.numConfig.defineCode] || 0)
        this.checkNumber(row)
        item.checkedMaterial.push(row.materielId)
      }

      // 检查当前供应商是否所有品目都授标
      const checkAll =
        item.checkedMaterial.length ===
        this.tableDataTemp.length / this.spanNum - item.someDisabled
      // 检查当前供应商是否有部分品目授标
      const someCheck = item.checkedMaterial.length > 0
      item.isIndeterminate = !checkAll && someCheck
      item.checkAll = checkAll
    },

    /**
     * 供应商全选授标处理
     * @param {Object} supplier 供应商表头信息
     */
    handleSupplierCheckAll(supplier) {
      supplier.checkAll = !supplier.checkAll

      // 如果全选，则将当前供应商的所有品目全勾选
      if (supplier.checkAll) {
        supplier.isIndeterminate = false
        for (
          let i = this.spanNum - 1;
          i < this.tableDataTemp.length;
          i += this.spanNum
        ) {
          const row = this.tableDataTemp[i]
          if (row.offerValue[supplier.supplierId].detailId) {
            row.offerValue[supplier.supplierId].check = true
            row.offerValue[supplier.supplierId].num =
              row[this.numConfig.defineCode]
            supplier.checkedMaterial.push(row.materielId)
          }
        }
      } else {
        // 如果取消权限，则将当前供应商的所有品目清除授标
        this.$antConfirm({
          title: '全部取消授标确认',
          content: '确定后将所有品目取消授标',
          icon: () => <a-icon type='exclamation-circle' />,
          onOk: () => {
            for (
              let i = this.spanNum - 1;
              i < this.tableDataTemp.length;
              i += this.spanNum
            ) {
              const row = this.tableDataTemp[i]
              row.offerValue[supplier.supplierId].check = false
              row.offerValue[supplier.supplierId].num = ''
            }
            supplier.checkedMaterial = []
          },
          onCancel: () => {
            // 如果点击取消，则需要恢复全选
            supplier.checkAll = true
          }
        })
      }
    },

    // 比较数值
    checkNumber(row) {
      if (!this.showTips) return

      let totalNum = 0
      Object.keys(row.offerValue).find(key => {
        if (row.offerValue[key].check) {
          totalNum =
            (totalNum * 100 + (row.offerValue[key].num || 0) * 100) / 100
        }
      })
      if (totalNum > Number(row[this.numConfig.defineCode])) {
        this.$alert('已超出采购量, 是否继续采购', '系统提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => (this.showTips = false)
        })
      }
    },

    // 根据报价次数返回中文文案
    roundNumHandle(num) {
      if (!num) return ''
      if (num == 1) {
        return '首次报价'
      } else {
        return `${nzhcn.encodeS(num)}次报价`
      }
    },

    /**
     * 获取当前行的展示内容
     */
    getRowValue(row, item) {
      const value = row.offerValue[item.supplierId].value || '-'
      if (value.includes('美元')) {
        return value
      }
      if (value.includes('元') && this.isDollar) {
        return strToThousands(value.replace('元', '美元'))
      }
      return value.includes('元') ? strToThousands(value) : value
    },

    /**
     * 当前行展示的内容是否需要右对齐
     */
    alignRight(row, item) {
      const needAlignRightArray = ['未含税价', '含税价', '总价']
      return needAlignRightArray.includes(row.offerName)
    },

    getTextColor(row, item) {
      const info = row.offerValue[item.supplierId]
      const offerName = row.offerName
      if (info.high) return 'text-danger'

      if (info.low) return 'text-success'

      if (offerName === '品牌/制作商' && info.value !== row.materielBrand) {
        return 'text-danger text-bold'
      }

      return ''
    },

    handleSelectAll(selection) {
      this.multipleSelection = uniqBy(selection, 'materielId')
      this.$emit(
        'selected',
        this.multipleSelection.map(item => item.materielId)
      )
    },

    handleSelect(selection, row) {
      const currentRowIndex = selection.findIndex(item => item === row)
      const sameIdIndex = selection.findIndex(
        item => item.materielId === row.materielId
      )

      if (currentRowIndex < 0 && sameIdIndex >= 0) {
        const checkedList = selection.filter(
          item => item.materielId !== row.materielId
        )
        this.multipleSelection = uniqBy(checkedList, 'materielId')
      } else {
        this.multipleSelection = uniqBy(selection, 'materielId')
      }
      this.$emit(
        'selected',
        this.multipleSelection.map(item => item.materielId)
      )
    },

    /**
     * 前端模拟分页：获取分页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.sizeMultiple
      const end = start + this.sizeMultiple
      this.pageTableData = this.tableDataTemp.slice(start, end)
    },

    /**
     * 根据当前分页与已选数据，进行反选
     */
    getIntersectionAndSelect() {
      // 取交集
      const intersection = [...this.tableDataTemp].filter(x =>
        [...this.echoList].some(y => y === x.materielId)
      )
      // 取差集
      const difference = [...this.tableDataTemp].filter(x =>
        [...intersection].every(y => y.materielId !== x.materielId)
      )

      if (this.$refs.table) {
        if (this.echoList.length > 0) {
          intersection.forEach(item => {
            this.$refs.table.toggleRowSelection(item, true)
          })
          difference.forEach(item => {
            this.$refs.table.toggleRowSelection(item, false)
          })
        } else {
          this.$refs.table.clearSelection()
        }
      }
    },

    /**
     * 修改供应商排序
     */
    handleChangeSort() {
      this.$emit('changeSort', this.sortType)
    },

    // 一键选择最低价
    handleSelectLowest() {
      // 过滤出所有选择授标量的行
      const tempArr = this.tableDataTemp.filter(v => {
        if (v.offerName === '选择授标数量') {
          return v
        }
      })

      if (JSON.stringify(tempArr[0]?.offerValue) === '{}') {
        this.$message.warning('无最低报价')
        return false
      }
      const supplierLow = []
      tempArr.forEach(v => {
        const tempPrice = v.offerValue
        Object.keys(tempPrice).forEach(key => {
          if (tempPrice[key].low && !supplierLow.includes(key)) {
            supplierLow.push(key)
          }
        })
      })
      // 过滤出含有最低报价的供应商并按报价时间排序
      const offerTimeArr = this.headerList
        .filter(v => {
          if (supplierLow.includes(String(v.supplierId))) {
            return v
          }
        })
        .sort((a, b) => {
          if (a.offerTime > b.offerTime) {
            return 1
          } else {
            return -1
          }
        })

      tempArr.forEach(v => {
        const tempPrice = v.offerValue
        // 找出当前品目（行）中所有的最低价
        const tempLowPrice = Object.keys(tempPrice).filter(
          key => tempPrice[key].low
        )
        if (tempLowPrice.length > 1) {
          // 如果单个品目有多个最低价，则根据报价时间顺序选择最早报价的供应商
          const lowestKey = Object.keys(tempPrice).find(key => {
            return (
              tempPrice[key].low &&
              offerTimeArr.findIndex(
                item => item.supplierId.toString() === key
              ) > -1
            )
          })
          if (lowestKey) {
            tempPrice[lowestKey].check = true
            tempPrice[lowestKey].num = Number(v[this.numConfig.defineCode] || 0)
          }
        } else {
          // 如果单个品目只有一个最低价，则直接选择该供应商
          tempPrice[tempLowPrice[0]].check = true
          tempPrice[tempLowPrice[0]].num = Number(
            v[this.numConfig.defineCode] || 0
          )
        }
      })
      // 针对每个供应商，查询供应商下的所有品目授标信息
      this.supplierHead.forEach(supplier => {
        const checkAll = tempArr.every(row => {
          return row.offerValue[supplier.supplierId].check
        })
        if (checkAll) {
          supplier.checkAll = true
          supplier.isIndeterminate = false
          return
        }

        const someCheck = tempArr.some(row => {
          return row.offerValue[supplier.supplierId].check
        })
        if (someCheck) {
          supplier.checkAll = false
          supplier.isIndeterminate = true
          return
        }
      })
    },

    // 获取单个品目的授标总量
    getAwardNum(row) {
      let awardNum = 0
      this.tableDataTemp.forEach((v, index) => {
        if (
          (index + 1) % this.spanNum === 0 &&
          v.materielId === row.materielId
        ) {
          const tempOffer = v.offerValue
          Object.keys(tempOffer).find(key => {
            if (tempOffer[key].check) {
              awardNum =
                (awardNum * 100 + (tempOffer[key].num || 0) * 100) / 100
            }
          })
        }
      })

      return awardNum.toFixed(2)
    },

    // 导出比价结果
    exportCompareInfo() {
      this.$emit('export')
    },

    // 导出报价单结果
    exportQuotaInfo() {
      this.$emit('exportQuota')
    },

    // 下载pdf
    async handleExportPdf() {
      const pdfData = await this.getPdfData()
      if (JSON.stringify(pdfData) == '{}') {
        return false
      }
      console.log('pdfdata', pdfData)
      // 二维码链接
      const url = `${process.env.VUE_APP_PASSPORT_URL}/message-verification?businessCode=${this.businessCode}`
      pdfData.qrCodeUrl = await qrcode.toDataURL(url)
      pdfData.isArchivist = true
      console.log('询比比价url', url)

      const tableHtml = await generateMaterielOfferHtml({
        pdfData,
        isDollar: this.isDollar,
        pdfTitle: '询比比价表',
        requireTax: this.requireTax
      })
      this.downloadPdf(tableHtml)
    },

    // 获取比价表pdf数据
    getPdfData() {
      return new Promise((resolve, reject) => {
        const params = {
          orderId: this.orderId
        }
        getInquiryOfferComparePdfApi(
          this.orderId,
          this.roundId,
          JSON.parse(this.sortType)
        )
          .then(res => {
            const data = res?.data || {}
            resolve(data)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            throw err
          })
      })
    },

    // 下载pdf
    downloadPdf(content) {
      const postData = {
        name: `询比比价表.pdf`,
        watermark: {
          watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
          watermarkWord: '精彩纵横云采购平台'
        },
        content: content
      }
      htmlToPdfApi(postData)
        .then(res => {
          getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
            window.open(fileRes.data.external, '_self')
            this.downloadsHistory(res.data)
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },

    // 调用附件下载记录接口
    downloadsHistory(attachmentId) {
      const params = {
        platform: process.env.VUE_APP_PLATFORM_CONSTANT,
        attachmentId: attachmentId,
        businessCode: this.businessCode,
        fileName: '询比比价表.pdf'
      }
      downloadsHistoryApi(params)
        .then(res => {
          console.log('res>>>>>', res)
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },

    /**
     * 当改变议价按钮
     */
    changeBargain(row) {
      Object.values(row.offerValue || {}).forEach(el => {
        el.bargainAmount = undefined
      })
    },

    isNumChecked(index, supplierId) {
      return !!this.tableDataTemp[index + 1].offerValue[supplierId].check
    },

    /**
     * 获取议价后总金额
     */
    getBargainTotal(supplierItem) {
      const itemData = {}
      this.tableDataTemp.forEach((k, i) => {
        const key = parseInt(i / this.spanNum)
        if (itemData[key]) {
          itemData[key].push(k)
        } else {
          itemData[key] = [k]
        }
      })

      const totalResult = Object.values(itemData).reduce((prev, cur, index) => {
        const totalObj = cur.find(item => item.offerName === '总价') || {}
        const bargainObj = cur.find(item => item.offerName === '议价') || {}

        const totalPrice = totalObj?.offerValue[supplierItem.supplierId]?.value
        const bargainAmount =
          bargainObj?.offerValue[supplierItem.supplierId]?.bargainAmount

        if (bargainAmount || bargainAmount == 0) {
          return prev + parseFloat(bargainAmount)
        } else {
          return prev + parseFloat(totalPrice)
        }
      }, 0)

      return totalResult.toFixed(2)
    },

    /**
     * 一键选择总价最低
     */
    handleSelectLowestTotal() {
      // 过滤出所有选择授标量的行
      const tempArr = this.tableDataTemp.filter(v => {
        if (v.offerName === '选择授标数量') {
          return v
        }
      })

      if (JSON.stringify(tempArr[0]?.offerValue) === '{}') {
        this.$message.warning('无最低报价')
        return false
      }

      // 获取最低总价
      const mixValue = Math.min.apply(
        Math,
        this.supplierHead.map(o => o[this.offerTotalPriceField])
      )

      // 获取总价最低的供应商，若有多个总价最低供应商，则根据报价时间顺序选择最早报价的供应商
      const supplierList = this.supplierHead.filter(
        item => item[this.offerTotalPriceField] == mixValue
      )
      supplierList.sort((a, b) => {
        if (a.offerTime > b.offerTime) {
          return 1
        } else {
          return -1
        }
      })

      if (!supplierList[0]?.checkAll) {
        this.handleSupplierCheck(supplierList[0])
      }
    },

    /**
     * 全选
     */
    selectAll() {
      this.$nextTick(() => {
        this.$refs.table.toggleAllSelection()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-top {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .compare-tips {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .compare-tips__item {
      display: flex;
      align-items: center;

      &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 2px;
        margin-right: 8px;
      }

      &.lowest::before {
        background-color: $success-color;
      }

      &.highest::before {
        background-color: $danger-color;
      }

      & + .compare-tips__item {
        margin-left: 10px;
      }
    }
  }
}

.info-item {
  display: flex;
  align-items: stretch;
  margin: 24px 0;
  line-height: 22px;

  &:first-child {
    margin-top: 16px;
  }
  &:last-child {
    margin-bottom: 16px;
  }

  .info-item-label {
    color: $text-color;
    width: 40%;
    margin-right: 24px;
    font-weight: bold;
  }
  .info-item-value {
    flex: 1;
    color: $second-text-color;
  }
}

.supplier-response {
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}
</style>
